<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-studentevaluate__evaluate-statistics">
            <el-form :inline="true" :model="dataForm">
                <el-form-item>
                    <el-input  placeholder="请输入标题" v-model="dataForm.taskTitle" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="rollCallDate"
                            type="daterange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getPage()">{{ $t('query') }}</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%;" @cell-dblclick="bccelldblclick">
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column prop="noticeTitle" label="标题" header-align="center" align="center"></el-table-column>
                <el-table-column prop="noticeContent" label="内容" header-align="center" align="center">
                    <el-table-column prop="noticeImg" label="图片" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.noticeImg" :src="scope.row.noticeImg" @click.stop="handleClickItem(scope.row)" :preview-src-list="noticeImg" fit="cover" style="width: 100px; height: 100px"></el-image>
                        </template>
                    </el-table-column>                   
                    <el-table-column prop="noticeContent" label="文字内容" header-align="center" align="center">
                    </el-table-column>                   
                </el-table-column>
                <el-table-column prop="scopeType" label="收集范围" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.scopeType == 1">全校</el-tag>
                        <el-tag v-else-if="scope.row.scopeType == 2" type="success">年级</el-tag>
                        <el-tag v-else-if="scope.row.scopeType == 3" type="warning">本班</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="receiveType" label="收集对象" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.receiveType == 0">家长</el-tag>
                        <el-tag v-else-if="scope.row.receiveType == 1" type="success">班主任</el-tag>
                        <el-tag v-else-if="scope.row.receiveType == 2" type="warning">教师</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="number" label="已读人数" header-align="center" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.totalReadNum }}/{{ scope.row.totalPersonNum }}
                    </template>
                </el-table-column>
                <el-table-column prop="startDate" label="发布时间" header-align="center" align="center"></el-table-column>
                <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button @click="onOperator(scope.row)" type="text" size="small">导出</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <el-pagination :current-page="pagelist.page" :page-sizes="[10, 20, 50, 100]" :page-size="pagelist.limit"
                :total="pagelist.total" @current-change="handleCurrentChange" @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            <!-- 已完成详情 -->
            <el-dialog width="1000px" :visible.sync="open" title="完成详情" append-to-body>
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="已读" name="first">
                        <el-table  v-loading="completedLoading" border :data="completeDataList">
                            <el-table-column prop="receiveName" label="姓名" header-align="center" align="center"></el-table-column>
                            <el-table-column prop="completeSituation" label="完成情况" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.isRead == 1" type="success">已读</el-tag>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination :current-page="completePagelist.page" :page-sizes="[10, 20, 50, 100]" :page-size="completePagelist.limit"
                            :total="completePagelist.total" @current-change="completeHandleCurrentChange" @size-change="completeHandleSizeChange"
                            layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="未读" name="second">
                        <el-table  v-loading="incompletedLoading" border :data="incompleteDataList">
                            <el-table-column prop="receiveName" label="姓名" header-align="center" align="center"></el-table-column>
                            <el-table-column prop="completeSituation" label="完成情况" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.isRead == 0" type="warning">未读</el-tag>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination :current-page="incompletePagelist.page" :page-sizes="[10, 20, 50, 100]" :page-size="incompletePagelist.limit"
                            :total="incompletePagelist.total" @current-change="incompleteHandleCurrentChange" @size-change="incompleteHandleSizeChange"
                            layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                    </el-tab-pane>
                </el-tabs>
            </el-dialog>
        </div>
    </el-card>
</template>

<script>
    export default {
        data () {
            return {
                pagelist: {
                page: 1,
                limit: 10,
                total: 0,
                },
                //已完成分页
                completePagelist: {
                page: 1,
                limit: 10,
                total: 0,
                },
                //未完成分页
                incompletePagelist: {
                page: 1,
                limit: 10,
                total: 0,
                },
                rollCallDate: '',
                dataForm:{
                    taskTitle: '',
                    startTime: '',
                    endTime: ''
                },
                url: ``,
                isRead: 1,
                noticeId: null,//信息Id
                activeName: 'first',
                open: false,
                dataListLoading: false,
                completedLoading: false,
                incompletedLoading: false,
                dataList: [],
                completeDataList: [],
                incompleteDataList: [],
                noticeImg: [],
            }
        },
        created(){
            this.getList()
        },
        methods: {
            //获取数据
            getList(){
                const params = {
                    page: this.pagelist.page,
                    limit: this.pagelist.limit,
                    taskTitle: this.dataForm.taskTitle,
                    startTime: this.dataForm.startTime,
                    endTime: this.dataForm.endTime
                }
                this.$http.get('/homeSchoolNotice/homeschoolnotice/page',{params}).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.dataList = res.data.list
                this.pagelist.total = res.data.total
                console.log(this.dataList)
            }).catch(() => { })
            },
            //图片
            handleClickItem(row){
                const srcList = []
                srcList.push(row.noticeImg)
                this.noticeImg = srcList
            },
            //搜索按钮
            getPage () {
                console.log(this.rollCallDate)
            if (this.rollCallDate === null || this.rollCallDate.length <= 1) {
                this.dataForm.startTime = ''
                this.dataForm.endTime = ''
                this.rollCallDate = []
                // return
            }
            if (this.rollCallDate.length >= 1) {
                const date = new Date(this.rollCallDate[0])
                this.dataForm.startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + '00:00:00'
                const date2 = new Date(this.rollCallDate[1])
                this.dataForm.endTime = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate() + ' ' + '23:59:59'
            }
            this.getList()
            console.log(this.dataForm)
            },
            //切换表
            handleClick(){
                console.log('切换表')
                if(this.activeName == 'first'){
                    this.isRead = 1
                    this.completePagelist.page = 1
                    this.completePagelist.limit = 10
                    this.completePagelist.total = 0
                    this.getCompleteDetails()
                }else{
                    this.isRead = 0
                    this.incompletePagelist.page = 1
                    this.incompletePagelist.limit = 10
                    this.incompletePagelist.total = 0
                    this.getInompleteDetails()
                }
            },
            //双击查看完成人数
            bccelldblclick(row, column, cell, event){
                console.log(row)
                console.log(column)
                console.log(event)
                this.activeName = 'first'
                this.isRead = 1
                this.noticeId = row.id   
                this.getCompleteDetails()
                if(column.property === "number"){
                    this.open = true
                    console.log('打开详情')
                }
            },
            //获取完成人数详情
            getCompleteDetails(){
                const params = {
                    page: this.completePagelist.page,
                    limit: this.completePagelist.limit,
                    noticeId: this.noticeId,
                    isRead: this.isRead
                }
                this.$http.get('homeSchoolNotice/homeschoolnoticelist/api/page',{params}).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.completeDataList = res.data.list
                this.completePagelist.total = res.data.total
                console.log(this.completeDataList)
                }).catch(() => { })
            },
            //获取未完成人数详情
            getInompleteDetails(){
                const params = {
                    page: this.incompletePagelist.page,
                    limit: this.incompletePagelist.limit,
                    noticeId: this.noticeId,
                    isRead: this.isRead
                }
                this.$http.get('homeSchoolNotice/homeschoolnoticelist/api/page',{params}).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.incompleteDataList = res.data.list
                this.incompletePagelist.total = res.data.total
                console.log(this.incompleteDataList)
                }).catch(() => { })
            },
            //导出按钮
            // onOperator(row) {
            //     let params = {
            //     noticeId: row.id
            //     }
            //     this.$http
            //     .get('infoCollection/infocollectiontasklist/api/export', { params })
            //     .then(({data: res}) => {
            //         if (res.code == 0) {
            //         console.log(res);
            //         this.url = res.data.url
            //         console.log(this.url)
            //         window.open(this.url)
            //         }
            //     })
            //     .catch((err) => {});
            // },
            //分页切换
            handleCurrentChange(val) {
                this.pagelist.page = val;
                console.log(this.pagelist.page);
                const params = {
                    page: this.pagelist.page,
                    limit: this.pagelist.limit,
                }
                this.$http
                    .get('/homeSchoolNotice/homeschoolnotice/page', { params })
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        console.log(res.data);
                        this.dataList = res.data.list;
                        this.total = res.data.total;
                        console.log(this.dataList);
                    });
            },
            handleSizeChange(val) {
                this.pagelist.limit = val
                console.log(this.pagelist.limit)
                const params = {
                    page: this.pagelist.page,
                    limit: this.pagelist.limit,
                }
                this.$http
                    .get('/homeSchoolNotice/homeschoolnotice/page', { params })
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        console.log(res.data);
                        this.dataList = res.data.list;
                        this.total = res.data.total;
                        console.log(this.dataList);
                    });
            },
            //已完成分页切换
            completeHandleCurrentChange(val) {
                this.completePagelist.page = val;
                console.log(this.pagelist.page);
                const params = {
                    page: this.completePagelist.page,
                    limit: this.completePagelist.limit,
                    isRead: this.isRead,
                    noticeId: this.noticeId,
                }
                this.$http
                    .get('homeSchoolNotice/homeschoolnoticelist/api/page', { params })
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        console.log(res.data);
                        this.completeDataList = res.data.list;
                        this.completePagelist.total = res.data.total;
                        console.log(this.dataList);
                    });
            },
            completeHandleSizeChange(val) {
                this.completePagelist.limit = val
                const params = {
                    page: this.completePagelist.page,
                    limit: this.completePagelist.limit,
                    isRead: this.isRead,
                    noticeId: this.noticeId,
                }
                this.$http
                    .get('homeSchoolNotice/homeschoolnoticelist/api/page', { params })
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        console.log(res.data);
                        this.completeDataList = res.data.list;
                        this.completePagelist.total = res.data.total;
                        console.log(this.dataList);
                    });
            },
            //未完成分页
            incompleteHandleCurrentChange(val) {
                this.incompletePagelist.page = val;
                const params = {
                    page: this.incompletePagelist.page,
                    limit: this.incompletePagelist.limit,
                    isRead: this.isRead,
                    noticeId: this.noticeId,
                }
                this.$http
                    .get('homeSchoolNotice/homeschoolnoticelist/api/page', { params })
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        console.log(res.data);
                        this.incompleteDataList = res.data.list;
                        this.incompletePagelist.total = res.data.total;
                        console.log(this.incompleteDataList);
                    });
            },
            incompleteHandleSizeChange(val) {
                this.incompletePagelist.limit = val
                const params = {
                    page: this.incompletePagelist.page,
                    limit: this.incompletePagelist.limit,
                    isRead: this.isRead,
                    noticeId: this.noticeId,
                }
                this.$http
                    .get('homeSchoolNotice/homeschoolnoticelist/api/page', { params })
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        console.log(res.data);
                        this.incompleteDataList = res.data.list;
                        this.incompletePagelist.total = res.data.total;
                        console.log(this.dataList);
                    });
            }
        },
        watch:{

        },
    }
</script>